import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import cn from 'classnames';
import { BottomSheet, BottomSheetContentLayout, Box, Button, Collapse, Typography } from 'seagull';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import styles from './PaymentMethodOption.module.scss';
const paymentMethodTypeTextMap = {
    bankAccount: 'Bank account',
    creditCard: 'Card'
};
const PaymentMethodOption = /*#__PURE__*/ forwardRef(function PaymentMethodOption(props, ref) {
    const { text = '', paymentMethodType, parenthesisText, icon, selected, className, disabled, mobileView, sheetTitle, onSheetClose, children, onOptionClick, testId, bottomSheetPaperStyle, bi } = props, rest = _object_without_properties(props, [
        "text",
        "paymentMethodType",
        "parenthesisText",
        "icon",
        "selected",
        "className",
        "disabled",
        "mobileView",
        "sheetTitle",
        "onSheetClose",
        "children",
        "onOptionClick",
        "testId",
        "bottomSheetPaperStyle",
        "bi"
    ]);
    const { CLIENT_ONBOARDING_NEW_FLOW } = useFeatureFlags();
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        ref: ref,
        "aria-selected": selected,
        className: cn(styles.optionWrapper, {
            [styles.selected]: selected,
            [styles.mobileView]: mobileView,
            [styles.disabled]: disabled,
            [styles.newUi]: CLIENT_ONBOARDING_NEW_FLOW,
            [styles.legacyOptionWrapper]: !CLIENT_ONBOARDING_NEW_FLOW,
            [styles.optionWrapperHoverable]: !disabled && !selected
        }, className),
        testId: testId
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                type: "button",
                className: cn(styles.option, {
                    [styles.newUiOrder]: CLIENT_ONBOARDING_NEW_FLOW,
                    [styles.legacyOrder]: !CLIENT_ONBOARDING_NEW_FLOW
                }),
                disabled: disabled,
                onClick: onOptionClick,
                testId: testId ? "".concat(testId, "-button") : undefined,
                bi: bi,
                children: CLIENT_ONBOARDING_NEW_FLOW ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            className: disabled ? styles.iconDisabled : styles.icon,
                            children: icon
                        }),
                        /*#__PURE__*/ _jsxs(Box, {
                            className: styles.name,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    as: "span",
                                    skin: disabled ? 'secondary' : 'standard',
                                    weight: "normal",
                                    children: paymentMethodType ? paymentMethodTypeTextMap[paymentMethodType] : text
                                }),
                                parenthesisText && /*#__PURE__*/ _jsxs(Typography, {
                                    testId: "payment-method-option-parenthesis",
                                    as: "span",
                                    variant: "paragraph2",
                                    skin: "secondary",
                                    className: styles.fee,
                                    children: [
                                        ' ',
                                        parenthesisText
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(Box, {
                            className: styles.name,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    as: "span",
                                    skin: disabled ? 'secondary' : 'standard',
                                    weight: "normal",
                                    children: paymentMethodType ? paymentMethodTypeTextMap[paymentMethodType] : text
                                }),
                                parenthesisText && /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        "\xa0",
                                        /*#__PURE__*/ _jsxs(Typography, {
                                            testId: "payment-method-option-parenthesis",
                                            as: "span",
                                            variant: "paragraph2",
                                            skin: "secondary",
                                            children: [
                                                "(",
                                                parenthesisText,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            className: disabled ? styles.iconDisabled : styles.icon,
                            children: icon
                        })
                    ]
                })
            }),
            mobileView && children && sheetTitle && onSheetClose && /*#__PURE__*/ _jsx(BottomSheet, {
                open: selected,
                onClose: onSheetClose,
                testId: testId ? "".concat(testId, "-sheet") : undefined,
                paperStyle: bottomSheetPaperStyle,
                children: /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
                    header: {
                        title: sheetTitle
                    },
                    contentGutter: "m",
                    children: children
                })
            }),
            mobileView && children && !(sheetTitle && onSheetClose) && /*#__PURE__*/ _jsx(Collapse, {
                in: selected,
                unmountOnExit: true,
                children: /*#__PURE__*/ _jsx(Box, {
                    className: styles.collapsedArea,
                    children: children
                })
            })
        ]
    }));
});
export default PaymentMethodOption;
